<template>
  <div :class="widthClass" class="CustomText lxn-pos-rel">
    <textarea
      :disabled="disabled"
      v-bind:value="value"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      v-on:input="$emit('input', $event.target.value)"
      :class="[$store.getters.language.font, $store.getters.language.directionClass, errorClass]"
      class="CustomText-input lxn-w100 lxn-title lxn-border-round lxn-text-center"
      :style="inputStyle"
      :placeholder="inputPlaceHolder"
      rows="3"
    />
    <div v-if="inputState" :class="inputState" class="CustomText-wrapper-statusBar lxn-pos-abs"></div>
    <div
      v-if="error !== undefined && error.hasError"
      :class="[this.$store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]"
      class="lxn-input-error-span"
    >
      {{ error.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomText",
  components: {},
  props: {
    placeHolder: String,
    value: [String, Number],
    inputState: String,
    bgColor: String,
    width: String,
    disabled: Boolean,
    error: Object,
  },
  data: function () {
    return {
      inputBgColor: this.bgColor || "#ECECEC",
    };
  },
  methods: {},
  computed: {
    errorClass: function () {
      if (this.error !== undefined && this.error.hasError) {
        return "lxn-input-error";
      } else {
        return "";
      }
    },
    inputPlaceHolder: function () {
      return this.placeHolder;
    },
    inputStyle: function () {
      var inputStyle = "";
      inputStyle += "background-color: " + this.inputBgColor + ";";
      if (!isNaN(this.width)) {
        inputStyle += "width: " + this.width + "px;";
      }
      return inputStyle;
    },
    widthClass: function () {
      if (this.width !== undefined) {
        return "lxn-w" + this.width;
      } else if (isNaN(this.width)) {
        return "lxn-w100";
      } else {
        return "lxn-undefined";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.CustomText {
}
.CustomText-input {
  color: #52626c;
  padding-top: 15px;
  padding-bottom: 15px;
}
.CustomText-wrapper-statusBar {
  height: 4px;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}
.CustomText-wrapper-statusBar.selected {
  background-color: #1ea5de;
}
.CustomText-wrapper-statusBar.error {
  background-color: #f36c4f;
}
.CustomText-wrapper-statusBar.active {
  background-color: #b8b8b8;
}
</style>
